<template>
  <div class="pagination-simple" v-if="total > 0">
    <div class="pagination-info">
      <div class="total">
        <b><span>{{ pageStartNum }} </span>—<span> {{ pageEndNum }}</span></b>
        <b class="pagination-info-total"> of {{ total }}</b>
      </div>
      <span>Count per page:</span>
      <div class="perpage">
        <multi-select
          v-if="options.length > 0"
          :multiple="false"
          :options="options"
          :allowEmpty="false"
          selectLabel=""
          deselectLabel=""
          selectedLabel=""
          placeholder=""
          v-model="pageLength"
          />
      </div>
    </div>
    <div class="pagination-list" v-if="!all || (all && pageLength < total)">
      <ul>
        <li @click="arrowsHandler('prev')" :class="page === 1 ? 'disabled' : ''">
          <svg width="100%" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.796335 5.76511L6.1436 0.83044C6.65184 0.361413 7.43511 0.361413 7.94335 0.83044C8.5127 1.35586 8.51272.25526 7.94335 2.78067L3.91304 6.5L7.94335 10.2193C8.5127 10.7447 8.5127 11.6441 7.94335 12.1696C7.43511 12.6386 6.65184 12.6386 6.1436 12.1696L0.796334 7.23489C0.367248 6.83891 0.367249 6.16108 0.796335 5.76511Z" fill="#5F5F5F"/>
          </svg>
        </li>
        <li class="all-button" v-if="all" @click="pageLength = total">
          All
        </li>
        <li v-for="(elem, index) in parginationList"
          :key="index"
          :class="[elem.page === page ? 'active' : '', elem.show ? '' : 'inactive']"
          @click="page = elem.show ? elem.page : page">
            {{ elem.show ? elem.page : '…' }}
        </li>
        <li @click="arrowsHandler('next')" :class="page === length ? 'disabled' : ''">
          <svg width="100%" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.20366 7.23489L2.8564 12.1696C2.34816 12.6386 1.56489 12.6386 1.05665 12.1696C0.4873 11.6441 0.4873 10.7447 1.05665 10.2193L5.08696 6.5L1.05665 2.78067C0.487301 2.25525 0.487302 1.35586 1.05665 0.830441C1.56489 0.361415 2.34816 0.361416 2.8564 0.830442L8.20367 5.76511C8.63275 6.16109 8.63275 6.83892 8.20366 7.23489Z" fill="#5F5F5F"/>
          </svg>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'PageinationSimple',
  components: {
    'multi-select': () => import('vue-multiselect'),
  },
  props: {
    // { page: 1, ppage: 10 }
    value: {
      type: Object,
      default: () => ({ page: 1 }),
    },
    total: {
      type: Number,
      default: () => 1,
    },
    options: {
      type: Array,
      default: () => [10, 25, 50, 100],
    },
    show: {
      type: Number,
      default: () => 5,
    },
    all: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    page() {
      this.emitter();
    },
    pageLength() {
      this.page = 1;
      this.emitter();
    },
  },
  data: () => ({
    pageLength: 1,
    page: 1,
  }),
  computed: {
    ppOptions() {
      return this.options.map((el) => ({ Name: el }));
    },
    length() {
      return Math.ceil(this.total / this.pageLength);
    },
    pageStartNum() {
      return (this.page - 1) * this.pageLength + 1;
    },
    pageEndNum() {
      const maxPage = this.page * this.pageLength;
      return maxPage > this.total ? this.total : maxPage;
    },
    parginationList() {
      const showItemsNumber = this.show % 2 === 0 ? this.show + 1 : this.show;
      if (this.length > showItemsNumber) {
        const showIndexDiff = (showItemsNumber - 3) / 2;
        return Array(this.length).fill().map((_, i) => i + 1).map((el) => ({
          page: el,
          show: el === 1 || el === this.length || el === this.page || (el <= this.page + showIndexDiff && el >= this.page - showIndexDiff),
        })).filter((el, ind, arr) => el.show || (!el.show && arr[ind - 1].show));
      } else {
        return Array(this.length).fill().map((_, i) => i + 1).map((el) => ({ page: el, show: true }));
      }
    },
  },
  methods: {
    emitter() {
      if (this.value.page !== this.page || this.value.ppage !== this.pageLength) {
        this.$emit('input', {
          page: this.page,
          ppage: this.pageLength,
        });
      }
    },
    arrowsHandler(type) {
      if (type === 'next') {
        if (this.page < this.length) {
          this.page++;
        }
      } else {
        if (this.page > 1) {
          this.page--;
        }
      }
    },
  },
  mounted() {
    this.pageLength = this.value.ppage ? this.value.ppage : this.options[0];
    this.page = this.value.page ? this.value.page : 1;
  },
});
</script>

<style lang="scss" scoped>
  .pagination-simple {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: flex-start;

    .total {
      margin-right: 10px;
    }

    .pagination-info {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;

      .pagination-info-total {
        color: #C5C5C5;
      }
    }

    .pagination-list {
      ul {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-end;

        li {
          height: 30px;
          width: 30px;
          margin: 0 5px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid transparent;
          transition: .3s all linear;
          cursor: default;

          &.all-button {
            color: #fff;
            font-weight: bold;
            background: #1D89BF;
            padding: 0 25px;
            width: auto;
          }

          &.active {
            background: #5F5F5F;
            color: #fff;
          }

          &:not(.active):not(.inactive):not(.disabled) {
            cursor: pointer;

            &:hover {
              border: 1px solid #5F5F5F;
            }
          }

          &.disabled {
            opacity: .4;
            pointer-events: none;
          }

          svg {
            height: 40%;
            width: 100%;
          }
        }
      }
    }
  }
</style>
